<div class="container mt-5">

  @if (hasApiError) {
  <div class="alert alert-danger" role="alert">
    {{apiError}}
  </div>
  }

  <div class="row align-items-center profile-header mb-5 text-center text-md-left">

    <div class="col-md">
      <h2>{{ this.org.name }}</h2>
      <p class="lead text-muted">{{ this.org.id }}</p>
    </div>
  </div>

  <h5>Organisation</h5>
  <div class="entity-field-group">
    <div class="entity-field">


      <label class="entity-name">{{org.name}}</label>
      <label class="entity-col1">CPUs:
        {{org.cpu_seconds_remaining}}</label>
      <button class="btn btn-primary entity-editfieldbtn" [hidden]="org.editing" (click)="toggleAddCredit()">+
        Credit</button>


      <div [hidden]="!org.editing" class="input-group credit-amount-field">
        <input type="text" class="form-control" id="invitationCode" type="number" [(ngModel)]="addCreditAmount" />
        <button class="btn btn-primary entity-midbtn" (click)="addCredit()">Add</button>
        <button class="btn btn-primary entity-rhbtn" (click)="toggleAddCredit()">Cancel</button>
      </div>

      <div class="mt-4">
        <h6>Enabled Apps</h6>
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="enableMotorTwin" [(ngModel)]="appAccess.motortwin" />
          <label class="form-check-label" for="enableMotorTwin">MotorTwin</label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="enableFmeda" [(ngModel)]="appAccess.fmeda" />
          <label class="form-check-label" for="enableFmeda">FMEDA</label>
        </div>
        <button class="btn btn-primary mt-2" (click)="saveAppAccess()">Save App Access</button>
        @if (appAccessSaved) {
        <div class="text-success mt-2">Saved app access for this organisation context.</div>
        }
      </div>
    </div>
  </div>

  <h5>Users</h5>
  <div class="entity-field-group">
    @for (user of this.orgUsers; track user) {
    <div class="entity-field">
      <div class="label-group">
        <label class="entity-name"><a routerLink="/user/{{user.socialuid}}">{{user.name}}</a></label>
        <label class="entity-col1">CPUs:
          {{user.cpu_seconds_remaining}}</label>
        <label class="entity-col2">Level: {{user.level}}</label>
      </div>
    </div>
    }


  </div>